import * as yup from 'yup';

export interface FormData {
  companyName: string;
  cvrNumber: string;
  name: string;
  phoneNumber: string;
  email: string;
  contactSecurityPackageConsent: boolean;
  memberType: string;
  contactOffersConsent: boolean;
}

yup.setLocale({
  mixed: {
    required: 'Dette felt er obligatorisk'
  }
});

export const validationSchema = (formData: FormData) => {
  return yup.object().shape({
    companyName: yup.string().required(),
    email: yup
      .string()
      .required()
      .email(`${formData.email} er ikke en gyldig email`),
    contactSecurityPackageConsent: yup
      .bool()
      .oneOf([true], 'Du skal give samtykke')
  });
};

export const to = (_body: any) => {
  return 'dibyggeri@gjensidige.dk';
};

export default validationSchema;
